<template>
  <v-container>
    <h2>Administration</h2>
    <h3>Vigtigt:</h3>

    <div>
      <h4>Fremmøde</h4>
      <div>12 fraværende</div>
      <div>- Anne har været væk i 4 - skriv til Anne her</div>
      <div>- Brian har været væk i 5 - skriv til Brian her</div>
    </div>
    <div>
      <h4>Fødselsdage</h4>
      <div>
        - Camilla har fødselsdag i dag
      </div>
      <div>- Dorthe har fødselsdag i morgen</div>
    </div>

    <div>
      <h4>Bevillinger</h4>
      <div>- Emilies bevilling udløber d.4/3</div>
      <div>- Frederiks bevilling udløber d.4/3</div>
    </div>

    <h4>Alle elever</h4>
    <h4>Alle ansatte</h4>
    <h4>Hold</h4>

    <h4>Sagsbehandlere</h4>
    <h4>Ukomplette profiler</h4>
    <div>- Gabriella - mangler hold</div>
    <div>- Henrik - mangler adresse</div>
    <div>- Iben - mangler funktion</div>
    <div>- Jens - mangler billede</div>
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
